import {
  getCatalogAppIdsV1,
  getItemsCountV1,
  getItemTypesV1,
} from '../utils/bi.utils';
import { SiteStore } from '@wix/wixstores-client-storefront-sdk';
import { CartV1 } from './current-cart-service/types';
import type { CartDiscount } from '@wix/auto_sdk_ecom_current-cart';

export class BIServiceV1 {
  private readonly siteStore: SiteStore;
  private readonly origin: string;

  constructor({ siteStore, origin }: { siteStore: SiteStore; origin: string }) {
    this.siteStore = siteStore;
    this.origin = origin;
  }

  public updateCartItemQuantityV1({
    origin,
    cart,
  }: {
    origin?: string;
    cart: CartV1;
  }) {
    return this.siteStore.platformBiLogger.updatedCartItemQuantitySf({
      origin: origin ?? this.origin,
      itemsCount: getItemsCountV1(cart.lineItems),
      cartId: cart._id!,
      catalogAppId: getCatalogAppIdsV1(cart.lineItems),
      checkoutId: cart.checkoutId!,
      purchaseFlowId: cart.purchaseFlowId!,
    });
  }

  public removeCouponV1({
    origin,
    discounts,
    cart,
  }: {
    origin?: string;
    discounts?: CartDiscount[];
    cart: CartV1;
  }) {
    const coupon = discounts?.find(
      (discount: CartDiscount) => discount.coupon,
    )?.coupon;
    return this.siteStore.platformBiLogger.removeACoupon({
      origin: origin ?? this.origin,
      cartId: cart._id!,
      couponCode: coupon?.code,
      catalogAppId: getCatalogAppIdsV1(cart.lineItems),
      checkoutId: cart.checkoutId ?? undefined,
      itemType: getItemTypesV1(cart.lineItems),
    });
  }

  public applyCouponV1({
    origin,
    couponCode,
    cart,
  }: {
    origin?: string;
    couponCode: string;
    cart: CartV1;
  }) {
    return this.siteStore.platformBiLogger.clickApplyCoupon({
      origin,
      couponCode,
      catalogAppId: getCatalogAppIdsV1(cart.lineItems),
      checkoutId: cart.checkoutId!,
      itemType: getItemTypesV1(cart.lineItems),
    });
  }

  public removeLineItemV1({ cart, origin }: { cart: CartV1; origin?: string }) {
    return this.siteStore.platformBiLogger.removedProductFromCartSf({
      cartId: cart._id!,
      origin: origin ?? this.origin,
      itemsCount: getItemsCountV1(cart.lineItems),
      catalogAppId: getCatalogAppIdsV1(cart.lineItems),
      checkoutId: cart.checkoutId!,
      purchaseFlowId: cart.purchaseFlowId!,
    });
  }
}
